import '@fortawesome/fontawesome-free/css/all.css';
import rootApp from 'views/components/mm_pro/views/root_app.vue';
import store from 'views/components/mm_pro/empresa/store/store';
import router from 'views/components/mm_pro/empresa/router/router.js';
import IdleVue from 'idle-vue-3';
import {
  borrar_sesion_local_storage,
  get_sesion_local_storage,
} from 'views/components/mm_pro/components/sesion.js';
import { iniciar_notificaciones_push } from 'views/components/mm_pro/components/notificaciones/fcm.js';
import { empty } from 'views/components/php.js';

Vue.prototype.base_url = base_url;
Vue.prototype.environment = environment;
Vue.prototype.is_app = is_app;
Vue.prototype.localStorage = localStorage;

if (!is_app) {
  Vue.use(IdleVue, {
    eventEmitter: new Vue(),
    idleTime: 60000,
  });
}

const app = new Vue({
  store,
  router,
  el: '#app',
  components: {
    rootApp,
  },
  onActive() {
    if (is_app || this.$router.currentRoute.path === '/login') {
      return;
    }
    this.$http
      .get(`${base_url}pro/sesion_mudancero_sigue_activa`, {}, { timeout: 30000 })
      .then((r) => {
        if (r.body.sesion_activa === false) {
          borrar_sesion_local_storage();
        }
      });
  },
  async mounted() {
    if (!is_app) {
      return;
    }

    const local_storage = get_sesion_local_storage();
    if (empty(local_storage)) {
      return;
    }

    console.log('es app e inició sesión');
    this.$nextTick(async () => {
      await iniciar_notificaciones_push();
    });
  },
});

export default app;
